<template>
  <div class="sidebar">
    <!--菜单部分-->
    <el-menu :default-active="$route.path"
             class="el-menu-vertical-demo sidebar-menu"
             :style="{height: `calc(100vh - 95}px)`}"
             text-color="rgba(0,0,0,0.65)"
             active-text-color="#fff"
             :collapse="isCollapse"
             :collapse-transition="true"
             :router="true">
      <template v-for="(item, index) in menuList">
        <template v-if="item.children">
          <menu-item :key="index" :parent-item="item"></menu-item>
        </template>
        <template v-else>
          <el-menu-item :index="item.strUrl" :key="index">
            <i :class="`iconfont ${item.icon||'menu'}`" style="color: rgb(191, 203, 217);margin-right: 10px"></i>
            <span class="menuTitle" slot="title">{{item.strName}}</span>
            <i class="font-color iconfont icon-right"></i>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
  </div>
</template>

<script>
import menuItem from '@/layout/menu-item'
import pages from '@/router/pages.js'
export default {
  name: 'Sidebar',
  components: {
    'menu-item': menuItem
  },
  data () {
    return {
      setBtnColor: '#',
      menuList: [],
      isCollapse: false
    }
  },
  created () {
    this.menuList = pages.pages
  },
  computed: {
  },
  methods:{
    // openMenus(key,keyUrl){
    //   console.log(key,keyUrl)
    // }
  }
}
</script>

<style lang="scss">
.sidebar {
  height: 100%;
  transition: all 0.2s;
  background: #304156;
}
.sidebar-title {
  height: 50px;
  background: #2b2f3a;
  .left-item-wrap {
    height: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    /*align-items: center;*/
    box-sizing: border-box;
    width: 200px;
    overflow: hidden;
    margin-right: 10px;
    transition: all 0.3s;
    /*background-color: #2b2f3a;*/
    background-color: blue;
    color: #fff;
  }
}
.sidebar-title-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background: rgba(255, 255, 255, 0.1);
}
.system-name {
  color: #fff;
  text-align: center;
  &:first-child {
    font-size: 13px;
    height: 18px;
    line-height: 18px;
  }
  &:last-child {
    font-size: 20px;
  }
}
.sidebar-menu {
  // height: calc(100vh - 50px);
  overflow: auto;
  overflow-x: hidden !important; 
  // background-color: rgb(82,95,111) !important;
}
.font-color {
  color: #bfcbd9;
  margin-left: 15px;
  margin-right: 0px;
  font-size: 20px;
  float: right;
}
.sidebar .el-menu  .el-menu-item {
    font-size: 15px !important;
  // background-color: rgb(82,95,111) !important;
    /*font-size: 15px;*/
}
.el-menu-item:focus, .el-menu-item:hover{
    background-color: #fff !important;
    color: #f5222d !important;
}
.sidebar .el-menu-item.is-active {
  color: #f5222d !important;
  background-color:#fff1f0 !important;
  border-right: 3px solid #f5222d;
  // color: #d2e4ff !important;
  // background-color: rgb(51,141,194) !important;
}
.sidebar .el-submenu__title{
    // background: rgb(60,71,86) !important;
    font-size: 16px !important;
    font-weight: bold !important;
}
.sidebar .el-menu-item{

}
.menuTitle{
    font-size: 16px;
    font-weight: bold;
}
</style>
